// Typelizer digest 1d9d14976f0001a9ab9438a9ff369084
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/classes/:class_id/students */
  index: (
    params: { teacherId: string | number; classId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/students', params, options),
    method: 'get',
  }),

  /** GET /educators/teachers/:teacher_id/classes/:class_id/students/:id */
  show: (
    params: { teacherId: string | number; classId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/students/:id', params, options),
    method: 'get',
  }),
}
